import { motion } from "framer-motion";
import { Hammer, Droplets, Zap, Lightbulb, Wrench, KeyRound, Ban } from "lucide-react";
import { SERVICES } from "../data";

const ICONS = { Hammer, Droplets, Zap, Lightbulb, Wrench, KeyRound };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28 bg-brand-bg">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-brand-olive font-medium tracking-widest uppercase text-sm mb-3">
            What I Do
          </p>
          <h2 className="font-display font-extrabold text-brand-brown text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            High-quality work across multiple trades.
          </h2>
          <p className="mt-4 text-brand-muted text-base sm:text-lg leading-relaxed">
            Everything is done with precision, care, and a commitment to getting
            it right the first time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`service-card-${i}`}
                className="group rounded-2xl bg-brand-surface border border-brand-line overflow-hidden hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(74,53,40,0.12)] transition-all duration-300"
              >
                <div className="h-44 overflow-hidden relative">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 w-11 h-11 rounded-xl bg-brand-bg/90 backdrop-blur flex items-center justify-center text-brand-olive">
                    <Icon size={22} />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-xl text-brand-brown tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-brand-muted text-sm leading-relaxed">{s.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="text-xs font-medium text-brand-olive bg-brand-olive/10 rounded-full px-3 py-1"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div
          data-testid="no-plastering-notice"
          className="mt-10 flex items-center justify-center gap-3 rounded-2xl border border-dashed border-brand-red/40 bg-brand-red/5 px-6 py-4 text-center"
        >
          <Ban size={18} className="text-brand-red shrink-0" />
          <p className="text-brand-red font-semibold text-sm sm:text-base">
            Please note: I do <span className="underline">not</span> offer plastering or painting.
          </p>
        </div>
      </div>
    </section>
  );
};
